import { createClient } from "@supabase/supabase-js";
import { SUPABASE_ANON_KEY, SUPABASE_URL } from "../env.js";

/** Browser Supabase client, ANON key only (never the service role key - that
 * never leaves the server, see functions/lib/supabase.ts). Used solely for
 * magic-link auth (signInWithOtp) and reading the current session's access
 * token to attach to /api/admin/* calls (see admin/src/lib/api.ts). */
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
